import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { PetService } from '../../../services/pet.service';
import { CatalogService } from '../../../services/catalog.service';
import { PetNoteModel,NoteModel } from '../../../models/pet-note.model';
import Swal from 'sweetalert2';
import { ClientService } from '../../../services/client.service';
import { ClientSearchResultsModel, TypeClientSearch } from '../../../models/search-client.model'; 
import { QuickNoteModel } from '../../../models/quick-note.model';
import { LabRecordModel } from '../../../models/lab-record.model';

declare var $: any;

@Component({
  selector: 'ngx-work-notes',
  styleUrls: ['./notes.component.scss'],
  templateUrl: './notes.component.html',
})
export class NotesComponent implements OnInit {

  private _pet_no: number;
  private _client_no: number = 0;
  show_all = false;
  search_typetxtbox: any = -1
  search_wordtxtbox: string = ''
  search_begin: string = ''
  search_end: string = ''

  DisplayedNotes: NoteModel[] = [];
  ritem: PetNoteModel;

  soap = false;
  selectedNoteTypes: number[] = [];
  create = false;
  editNotetype = false;

  filterType: string = 'pet';
  filter_pet_no: number = 0;

  note_write1: string = '';
  note_write: string = '';
  note_soap: {note: string, type: number}[] = [
    {note: '', type: 22},
    {note: '', type: 23},
    {note: '', type: 24},
    {note: '', type: 25},
    {note: '', type: 26}, 
  ];
  note_types: any[] = [];
  quick_notes: QuickNoteModel[] = []

  Altered_QuickText: string = '';

  // Pagination state for infinite scroll
  isLoading: boolean = false;
  hasMore: boolean = true;
  allDataLoaded: boolean = false;
  currentPage: number = 1;
  pageSize: number = 20;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.filter_pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public sharedService: SharedService,
    public petService: PetService,
    public clientService: ClientService,
    public catalogService: CatalogService,
    private route: ActivatedRoute
  ) {
    this.DisplayedNotes = this.petService.notes
  }

  ngOnInit() {
    // Claim the shared "current pet" tracker with whatever pet_no was actually
    // bound to this instance, so a stale value left over from a previous,
    // unrelated page (changePet is a BehaviorSubject shared app-wide) doesn't
    // immediately overwrite it via the subscription below.
    this.petService.changePetVar(this.pet_no);

    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          Swal.fire({
            title: 'Loading...',
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
            },
          })

          this.pet_no = message;
          this.DisplayedNotes = [];
          this.loadInitialData();
          Swal.close();

          this.catalogService.getQuickNote()
        }
      });

    // this.clientService.selectedClient
    //   .subscribe((message: ClientSearchResultsModel) => {
    //     Swal.fire({
    //       title: 'Loading...',
    //       timerProgressBar: true,
    //       didOpen: () => {
    //         Swal.showLoading()
    //       },
    //     })

    //     this.petService.getPetsByClient(Number(message.client_no))
    //       .then(async () => {
    //         Swal.close();

    //         if (this.petService.pets && this.petService.pets.length > 0) {
    //           let options = {};
    //           this.petService.pets.forEach((element, index) => {
    //             if (this.ritem != null){
    //               if (Number(element.pet_no) !== Number(this.ritem.pet_no))
    //                 options[`${element.pet_no}`] = element.pet_name;
    //             } else {
    //               options[`${element.pet_no}`] = element.pet_name;
    //             }
    //           });
    //           const { value: selection } = await Swal.fire({
    //             title: `Select pet from ${message.client_name} to re assign this note`,
    //             input: 'select',
    //             inputOptions: options,
    //             // inputPlaceholder: 'Select a fruit',
    //             showCancelButton: false,
    //             inputValidator: (value) => {
    //               return new Promise((resolve) => {
    //                 resolve(undefined)
    //               })
    //             }
    //           })

    //           if (selection) {
    //             Swal.fire({
    //               title: 'Re assign this note?',
    //               // icon: 'warning',
    //               showCancelButton: true,
    //               cancelButtonText: 'No',
    //               confirmButtonText: 'Yes'
    //             }).then((result: any) => {
    //               if (result.isConfirmed) {
    //                 Swal.fire({
    //                   title: 'Loading...',
    //                   timerProgressBar: true,
    //                   didOpen: () => {
    //                     Swal.showLoading()
    //                   },
    //                 })

    //                 this.ritem.pet_no = Number(selection);                    
    //                 this.petService.reasignPetNote(this.ritem)
    //                   .then(() => {
    //                     this.petService.getNotesByPetId(this.pet_no)
    //                       .then(() => {
    //                         this.DisplayedNotes = []
    //                         this.DisplayedNotes = this.petService.notes
    //                         Swal.close();
    //                       });
    //                   });
    //               }
    //             });
    //           }
    //         }
    //       });
    //   });

    this.petService.selectedNotes
      .subscribe(message => {
        if (message) {
          this.DisplayedNotes = []
          this.DisplayedNotes = this.petService.notes
        }
      });

    this.petService.notify_LabDataSavedObservable
      .subscribe(() => {
        this.loadInitialData();
      });

    this.catalogService.getNoteType().then(() => {});

    this.loadInitialData();
  }

  add() {
    this.petService.pet_note = new PetNoteModel(0, '', 0, 0, '', '', '');
    this.petService.selectedGenericQuick(true);
    $('#modalNewPetNote').modal('toggle')
  }

  edit(item: NoteModel) {  
    this.petService.note = item;
    this.note_write1 = item.notetext.replace(/\[image:\d+\]/g, '').replace(/\[file:\d+\]/g, '').trim();
    this.disableEditNoteType();

    $('#modalEditNote').modal('toggle') 
  }

  assign(item: PetNoteModel) {
    this.ritem = item;
    this.clientService.clients = [];
    this.clientService.search.page_number = 1;
    this.clientService.search.type = TypeClientSearch.SELECT;
    $('#modalSearchClient').modal('toggle')
  }

  delete(item: NoteModel) {
    Swal.fire({
      title: 'Delete this note?',
      // icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes'
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Loading...',
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
          },
        }) 

        this.petService.DeleteNote(item.note_sequence, item.notetype_list).then(() => {
          this.DisplayedNotes = this.DisplayedNotes.filter(note => note.note_sequence !== item.note_sequence);
          Swal.close();
        }).catch((msg: string) => {
          Swal.close();
          setTimeout(() => Swal.fire({ title: msg, icon: 'warning' }), 200);
        });
      }
    });
  }

  rows(text) {
    if (!text) {
      return '';
    }
    var numerOfRowsInText = text.split('\n').length; // rows number - 500
    // console.log(numerOfRowsInText); //row number
    return numerOfRowsInText;
  }

  async showAll() {
    await this.petService.pet_notes.forEach(element => {
      element.show_more = this.show_all;
    });
  }

  async search_click() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.DisplayedNotes = [];
    this.petService.search_begin = this.search_begin;
    this.petService.search_end = this.search_end;
    this.loadInitialData();
    Swal.close();

    
  }

  order(_order: number) {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.DisplayedNotes = [];
    this.petService.notes_order = _order;
    this.loadInitialData();
    Swal.close();
  }
 
  //#region Create Note by HRY
  onCheckboxChange(event: Event, noteType: number): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedNoteTypes.push(noteType);
    } else {
      const index = this.selectedNoteTypes.indexOf(noteType);
      if (index > -1) {
        this.selectedNoteTypes.splice(index, 1);
      }
    } 
  }

  AddNote(){
      if(!this.soap){
        console.log("!soap", this.note_write);

          if (!this.note_write || this.note_write.trim() === '') {
            Swal.fire({
              title: 'Note is empty',
              text: 'Please write a note before saving.',
              icon: 'warning',
              confirmButtonText: 'OK'
            });
            return;
          }

          let collected_types = [...this.selectedNoteTypes]; 
          if (collected_types.length === 0) {
            Swal.fire({
              title: 'No Note Type Selected', 
              text: 'Please select at least one note type before saving.',
              icon: 'warning',
              confirmButtonText: 'OK'
            });
            return;
          }
          let fnote_write = this.note_write + " -- " + this.clientService.userData.employee_name; 
          this.petService.note.notetext = fnote_write;
          this.petService.note.pet_no = this.pet_no;
          this.petService.note.notetype_list = collected_types
          this.petService.setupNote().then(() => {
              Swal.fire({
                icon: 'success',
                title: 'Note Saved',
                text: 'The Note has been added successfully.'
              });

              this.loadInitialData();
              Swal.close();
          });
      }
      else{ 
        console.log("soap", this.note_soap);
          const promises = this.note_soap.map((element) => {
              let collected_types = this.selectedNoteTypes.slice();
              collected_types.push(element.type);
              element.note = element.note + " -- " + this.clientService.userData.employee_name;
              this.petService.note = new NoteModel(0, this.pet_no,  '','', element.note, collected_types); 
              return this.petService.setupNote();
          });

          Promise.all(promises).then(() => {
              Swal.fire({
                title: 'Success',
                text: 'All notes have been set up successfully.',
                icon: 'success',
                confirmButtonText: 'OK'
              });

              this.loadInitialData();
              Swal.close();
          })
      }

      this.petService.note = new NoteModel(0, this.pet_no, '','', '', [], false);
      this.note_write = '';
      this.note_soap = [
        {note: '', type: 22},
        {note: '', type: 23},
        {note: '', type: 24},
        {note: '', type: 25},
        {note: '', type: 26}, 
      ]
  }

  
  getNoteTypesText(noteTypes: number[]): string {
    return noteTypes.map(notetype => {
      const noteType = this.catalogService.note_type.find(item => item.notetype === notetype);
      return noteType ? noteType.notename : 'Unknown';
    }).join(' ');
  }

  labdata(){
    $('#modallabdata').modal('show');
    this.petService.notifyLabRecFunction();
  }

  checkValue(event: any) {
    var checked = Boolean(event.target.checked);
    var code = Number(event.target.value);

    switch (checked) {
      case true:
        switch (code) {
          case 0:
          case 3:
            for (let index = 0; index < this.note_types.length; index++) {
              const element = this.note_types[index];
              if (element.code === 2 || element.code === 7 || element.code === 1 || element.code === 8) {
                element.selected = false;
              }
            }
            break;
          default:
            for (let index = 0; index < this.note_types.length; index++) {
              const element = this.note_types[index];
              if (element.code === 0 || element.code === 3) {
                element.selected = false;
              }
            }
            break;
        }

        if (this.catalogService.quick_notes.some(t => Number(t.quick_note_type) === code)) {
          this.quick_notes.push(...this.catalogService.quick_notes.filter(t => Number(t.quick_note_type) === code));
        }
        break;
      default:
        if (this.quick_notes.some(t => Number(t.quick_note_type) === code)) {
          var tmp = this.quick_notes.filter(t => Number(t.quick_note_type) !== code);
          this.quick_notes = [];
          this.quick_notes.push(...tmp);
        }
        break;
    } 
  }
  
  txtbix_from = 0;

  openQuickNote(from: number) {
    this.txtbix_from = from;
    this.quick_notes = [];
    this.checkValue({ target: { value: 2, checked: true } })
    $('#modalQuickNote').modal('show');
  }

  clickQuickNoteBtn(item: QuickNoteModel) { 
    this.Altered_QuickText = item.quick_note_text
    $('#modalQuickNoteText').modal('show');
  }

  applyQT(){
    if(this.txtbix_from === 0){
      this.note_write = this.Altered_QuickText
    }
    else{
      this.note_soap[this.txtbix_from - 1].note = this.Altered_QuickText
    } 

    $('.modal').modal('hide');
  }

  clickQuickDiagnosis(){
    let txtdiagnosis = '';
    this.petService.pet_problems.forEach(element => {
      if(element.status !== 2){
        txtdiagnosis += element.PreferredTerm + ' — ' +  element.datedesc  + '\n';
      } 
    });
    this.Altered_QuickText = txtdiagnosis
    $('#modalQuickNoteText').modal('show');

    this.selectedNoteTypes.push(2,38);
  }

  isSelected(notetype: number): boolean {
    return this.selectedNoteTypes.includes(notetype);
  }

  saveEdit(){
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    }) 

    const originalText = this.petService.note.notetext;
    const placeholders = originalText.match(/\[image:\d+\]|\[file:\d+\]/g) || [];
    const finalText = `${placeholders.join(' ')} ${this.note_write1}`.trim();

    this.petService.note.notetext = finalText;

    console.log(this.petService.note)
    this.petService.setupNote().then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Note Saved',
          text: 'The Note has been added successfully.'
        });

        $(".modal").modal("hide");

        this.loadInitialData();
        Swal.close();
    });
  }

   
  disableEditNoteType() {
    this.editNotetype = this.catalogService.note_type.some(element => 
      !element.allowwrite && this.petService.note.notetype_list.includes(element.notetype)
    );
  }

  //#endregion

  //for notes with image id [image:1] - HRY
  parseNote(note: string) {
    const imageMatch = note.match(/\[image:(\d+)\]/);
    const fileMatch = note.match(/\[file:(\d+)\]/);
    const imageId = imageMatch ? imageMatch[1] : null;
    const fileId = fileMatch ? fileMatch[1] : null;
    const text = note.replace(/\[image:\d+\]/g, "").replace(/\[file:\d+\]/g, "").trim();

    return { text, imageId, fileId };
  }

  imageData: any = null;
  getImage(imageId){
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.petService.getImage(imageId).then((res) => {
      this.imageData = res    
      $('#imageModal').modal('show');
      Swal.close();
    });
  }

  getDocument(fileId){
    this.sharedService.viewPdf(fileId);
  }

  labtest_table:LabRecordModel[] = [];

  getLabTest(item:any){
    try {
      // Parse the JSON string into an array of objects
      const labTests = JSON.parse(item);

      // Map the parsed data into the LabRecordModel
      this.labtest_table = labTests.map((test: any) => {
          return new LabRecordModel(
              test.labtest_id,
              test.pet_no,
              test.labtest_val,
              test.test_code,
              test.test_desc,
              test.labtest_date,
              test.recordedby,
              test.units,
              test.range,
              test.comment
          );
      });
 
      $('#modalLabTestTable').modal('show');
    } catch (error) {
        console.error('Error parsing lab test JSON:', error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to parse lab test data.',
        });
    }
  }

  isValueOutOfRange(labtest_val: number, range: string): boolean { 
    if (!range || labtest_val === null || labtest_val === undefined || range === '-') {
        return false; // Return false if range or value is invalid
    }  

    // Check for single-sided range conditions
    if (range.startsWith('<')) {
        const max = parseFloat(range.replace('<', '').trim());
        if (isNaN(max)) {
            console.error('Invalid range format:', range);
            return false;
        }
        return labtest_val >= max; // Out of range if value is greater than or equal to max
    }

    if (range.startsWith('>')) {
        const min = parseFloat(range.replace('>', '').trim());
        if (isNaN(min)) {
            console.error('Invalid range format:', range);
            return false;
        }
        return labtest_val <= min; // Out of range if value is less than or equal to min
    }

    // Handle standard range format (e.g., "70-138")
    const [min, max] = range.split('-').map(val => parseFloat(val.trim()));

    if (isNaN(min) || isNaN(max)) {
        console.error('Invalid range format:', range);
        return false;
    }

    return labtest_val < min || labtest_val > max; // Out of range if value is outside the range
}
 
  samp(){
    //console.log(this.catalogService.note_type) 
    console.log(this.petService.notes) 
    console.log(this.catalogService.note_type) 

  }

  // Pagination methods (like your example)
  loadInitialData() {
    this.currentPage = 1;
    this.hasMore = true;
    this.allDataLoaded = false;
    this.DisplayedNotes = [];
    this.loadMoreData();
  }

  loadMoreData() {
    if (this.isLoading || !this.hasMore || this.allDataLoaded) {
      return;
    }

    this.isLoading = true;

    const begin = this.search_begin || '';
    const end = this.search_end || '';

    this.petService.getNotePaginated(this.filter_pet_no, this.client_no, this.currentPage, this.pageSize, begin, end, this.search_wordtxtbox, (isNaN(this.search_typetxtbox)|| this.search_typetxtbox == -1? '' : this.search_typetxtbox))
      .then((result: any) => {
        this.isLoading = false;

        const items: NoteModel[] = (result && result.items) ? result.items : [];

        // Apply client-side filters (text + type)
        const word = (this.search_wordtxtbox || '').toLowerCase();
        const typeFilter = Number(this.search_typetxtbox);
        const filtered = items.filter(note => {
          const matchesWord = word !== '' ? (note.notetext || '').toLowerCase().includes(word) : true;
          let matchesType = true;
          if (!isNaN(typeFilter) && typeFilter !== -1) {
            matchesType = Array.isArray(note.notetype_list)
              ? note.notetype_list.includes(typeFilter as any)
              : (note as any).notetype_list === typeFilter;
          }
          return matchesWord && matchesType;
        });

        this.DisplayedNotes.push(...filtered);

        this.hasMore = result && result.hasMore;
        if (this.DisplayedNotes.length === 0 && (!result || !result.hasMore)) {
          this.allDataLoaded = true;
        }
        if (this.hasMore) {
          this.currentPage++;
        } else {
          this.allDataLoaded = true;
        }
      })
      .catch((error) => {
        this.isLoading = false;
        console.error('Error loading notes:', error);
      });
  }

  // Window scroll listener to trigger infinite loading
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    const element = event.target.documentElement;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      this.loadMoreData();
    }
  }

  // Container scroll (preferred to avoid window-level interference)
  onContainerScroll(event: any) {
    const el = event.target as HTMLElement;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;
    if (nearBottom) {
      this.loadMoreData();
    }
  }

  setFilterType(type: string) {
    this.filterType = type;
    if(this.filterType === 'pet'){
      this.filter_pet_no = this.pet_no;
    }
    else{
      this.filter_pet_no = 0;
    }
  }


}
